'use client'

import { BannerText } from "@/components/molecules/BannerText/BannerText";
import { Button } from "@/components/atoms/Button/Button";
import { TwoColContainer } from "@/components/atoms/TwoColContainer/TwoColContainer";
import { ComponentContainer } from "@/components/atoms/ComponentContainer/ComponentContainer";
import { PageContent } from "@/components/organisms/PageContent/PageContent";
import * as Styled from './ErrorPage.styled';


export function ErrorPage({locale, retryFunction}: {locale: 'en' | 'es', retryFunction: () => void}) {

	return (
		<PageContent>
			<Styled.ErrorPage>
				<BannerText
					title={{
						en: 'Something went wrong',
						es: 'Algo salió mal'
					}} 
					textLg={{
						en: 'The page you are looking for could not be loaded.',
						es: 'La página que buscas no se pudo cargar.'
					}}
					animationContainer={{
						type: 'none'
					}}
					borderTop={false}
					className="error-banner"
				/>
				<ComponentContainer>
				<TwoColContainer sideTitle={' '}>
					<Button callbackOnClick={retryFunction}>{locale === 'en' ? 'Try again' : 'Intentar de nuevo'}</Button>
				</TwoColContainer>
				</ComponentContainer>
			</Styled.ErrorPage>
		</PageContent>
	);
}